/*
 * @Description: 
 */

import axios from 'axios'
import { Loading,Message } from 'element-ui';
import Tools from '../utils/tools'
let tempAxios = 0;

// axios.defaults.withCredentials=true;

const Axios = axios.create({

    baseURL: process.env.VUE_APP_API,
    headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
    // timeout: 5000                  // 超时
})



Axios.interceptors.request.use(config => {
    // console.log(sessionStorage.token)
    // if (sessionStorage.token) {
        // config.headers.ignoreCancelToken ='true',

        // config.headers['Cookie'] = 'jeesite.session.id=e9dee2169ab14d66b269dc1905ad2a4d;';
    // }
    // let ret = new FormData();
    // for (let it in config.data) {
    //     ret.append(it, config.data[it]);  
    // }
    // console.log('===',ret)
    // tempAxios=0;
    //     if(config.loadingHide!=false){
    //         tempAxios ++;
    //         let loading = Loading.service({
    //         fullscreen: true,
    //         });
    //     } 
    // config.data = ret;
    return config;
}, error => {
    //     console.log("发送失败");
        let loading = Loading.service({});
        loading.close();    
        return Promise.reject(error);
    });

Axios.interceptors.response.use(response => {
    // if(response.config.loadingHide!=false) {
    //     let loading = Loading.service({});
    //     loading.close();
    // }

    // if(!response.data.isValidCodeLogin){
    //     Message({
    //         message:response.data.message,
    //         type: 'warning'
    //     })
    //     // alert(response.data.message);
    // }
    // } else if(response.data.errorCode == 3){     // 返回信息
    //     alert(response.data.errorMsg)
    // } else {
        return response.data;
    // }
},error => {
    // let loading = Loading.service({});
    //     loading.close();  
    // alert('用户session过期，请重新登录！')
    throw Promise.reject(error)
})



export default Axios